// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.VectorLayerPicker {\n    display: flex;\n    align-items: center;\n}\n\ndiv.VectorLayerPicker > select {\n    margin: 0.25em 0;\n    flex: 1 1 auto;\n}\n", ""]);
// Exports
module.exports = exports;
